import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Toolbar, Typography } from '@mui/material';

const TicketTableToolbar: FC = () => {
  const { t } = useTranslation('followUp');

  return (
    <Toolbar
      sx={(theme) => ({
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        gap: theme.spacing(2),
      })}
    >
      <Typography variant="h3" component="h6">
        {t('toolBar.headline')}
      </Typography>
    </Toolbar>
  );
};

export default TicketTableToolbar;
